const TelecomFieldsValidation = (
  field,
  validations,
  mandatoryFunction,
  offerConfig,
  customerData,
  billingData,
  mainAddressData,
  telecomContractData,
  telecomCharacteristicsData,
  identityData,
) => {
  const productType = telecomCharacteristicsData.productType ?? ''
  const zipcode = mainAddressData.zipcode ?? ''

  switch (field) {
    case 'zohoId':
      return {
        isValid: validations.zohoId(customerData.zohoId ?? ''),
        isMandatory: true,
      }
    case 'productType':
      return {
        isValid: productType !== '',
        isMandatory: true,
      }
    case 'prestationType':
      return {
        isValid: validations.prestationType(telecomCharacteristicsData.prestationType ?? ''),
        isMandatory: true,
      }
    case 'offerId':
      return {
        isValid: validations.offerId(telecomContractData.offerId ?? 0),
        isMandatory: true,
      }
    case 'providerId':
      return {
        isValid: validations.providerId(telecomContractData.providerId ?? 0),
        isMandatory: true,
      }
    case 'cityId':
      return {
        isValid: validations.cityId(mainAddressData.city ?? '', zipcode, mainAddressData.inseeCode ?? ''),
        isMandatory: true,
      }
    case 'dataCollectionAuth':
      return {
        isValid: validations.dataCollectionAuth(customerData.dataCollectionAuth ?? false),
        isMandatory: true,
      }
    case 'tenantType':
      return {
        isValid: validations.tenantType(mainAddressData.tenantType?.length ?? ''),
        isMandatory: mandatoryFunction.tenantType(mainAddressData.city ?? ''),
      }
    case 'civility':
      return {
        isValid: validations.civility(customerData.civility ?? '', customerData.dataCollectionAuth ?? false),
        isMandatory: true,
      }
    case 'civility2':
      return {
        isValid: validations.civility2(
          customerData.civility2 ?? '',
          customerData.secondName,
          customerData.dataCollectionAuth ?? false,
        ),
        isMandatory: mandatoryFunction.civility2(customerData.secondName ?? false),
      }
    case 'name':
      return {
        isValid: validations.name(customerData.dataCollectionAuth ?? false, customerData.name ?? ''),
        isMandatory: true,
      }
    case 'name2':
      return {
        isValid: validations.name2(customerData.secondName, customerData.dataCollectionAuth, customerData.name2 ?? ''),
        isMandatory: mandatoryFunction.name2(customerData.secondName ?? false),
      }
    case 'surname':
      return {
        isValid: validations.surname(customerData.surname ?? ''),
        isMandatory: true,
      }
    case 'surname2':
      return {
        isValid: validations.surname2(
          customerData.secondName,
          customerData.dataCollectionAuth,
          customerData.surname2 ?? '',
        ),
        isMandatory: mandatoryFunction.surname2(customerData.secondName ?? false),
      }
    case 'phone1':
      return {
        isValid: validations.phone1(customerData.phone1 ?? ''),
        isMandatory: true,
      }
    case 'phone2':
      return {
        isValid: validations.phone2(customerData.phone2 ?? '', customerData.dataCollectionAuth ?? false),
        isMandatory: false,
      }
    case 'iban':
      return {
        isValid: validations.iban(billingData.iban ?? ''),
        isMandatory: mandatoryFunction.iban(billingData?.paymentMode),
      }
    case 'bic':
      return {
        isValid: validations.bic(billingData.bic ?? ''),
        isMandatory: mandatoryFunction.bic(billingData?.paymentMode),
      }
    case 'address':
      return {
        isValid: validations.address(mainAddressData.address?.length ?? ''),
        isMandatory: true,
      }
    case 'zipcode':
      return {
        isValid: validations.zipcode(zipcode),
        isMandatory: true,
      }
    case 'socialReason':
      return {
        isValid: validations.socialReason(customerData.pro_social_reason ?? ''),
        isMandatory: mandatoryFunction.socialReason(telecomCharacteristicsData.contractType),
      }
    case 'siret':
      return {
        isValid: validations.siret(customerData.pro_siret ?? ''),
        isMandatory: mandatoryFunction.siret(telecomCharacteristicsData.contractType),
      }
    case 'email':
      return {
        isValid: validations.email(customerData.email ?? '', customerData.dataCollectionAuth ?? false),
        isMandatory: true,
      }
    case 'comments':
      return {
        isValid: validations.comments(customerData.comments),
        isMandatory: mandatoryFunction.comments(offerConfig),
      }
    case 'identityDocumentNumber':
      return {
        isValid: validations.identityDocumentNumber(identityData.documentNumber),
        isMandatory: mandatoryFunction.identityDocumentNumber(),
      }
    case 'identityExpirationDate':
      return {
        isValid: validations.identityExpirationDate(identityData.expirationDate),
        isMandatory: mandatoryFunction.identityExpirationDate(),
      }
    case 'identityCreatedDate':
      return {
        isValid: validations.identityCreatedDate(identityData.createdDate),
        isMandatory: mandatoryFunction.identityCreatedDate(),
      }
    case 'identityIssuingEntity':
      return {
        isValid: validations.identityIssuingEntity(identityData.issuingEntity),
        isMandatory: mandatoryFunction.identityIssuingEntity(),
      }
    case 'identityIssuingCity':
      return {
        isValid: validations.identityIssuingCity(identityData.issuingCity),
        isMandatory: mandatoryFunction.identityIssuingCity(),
      }
    case 'taxIdCode':
      return {
        isValid: validations.taxIdCode(customerData.tax_id_code),
        isMandatory: mandatoryFunction.taxIdCode(),
      }
    case 'accountHolderFirstname':
      return {
        isValid: validations.accountHolderFirstname(billingData.accountHolderFirstname ?? ''),
        isMandatory: mandatoryFunction.accountHolderFirstname(billingData?.differentAccountHolder),
      }
    case 'accountHolderLastname':
      return {
        isValid: validations.accountHolderLastname(billingData.accountHolderLastname ?? ''),
        isMandatory: mandatoryFunction.accountHolderLastname(billingData?.differentAccountHolder),
      }
    case 'accountHolderTaxIdCode':
      return {
        isValid: validations.accountHolderTaxIdCode(billingData.accountHolderTaxIdCode ?? ''),
        isMandatory: mandatoryFunction.accountHolderTaxIdCode(billingData?.differentAccountHolder),
      }
    case 'mobileMigrationCode':
      return {
        isValid: validations.mobileMigrationCode(telecomCharacteristicsData.mobileMigrationCode ?? ''),
        isMandatory: mandatoryFunction.mobileMigrationCode(telecomCharacteristicsData?.prestationType),
      }
    case 'iccidMigration':
      return {
        isValid: validations.iccidMigration(telecomCharacteristicsData.iccidMigration ?? ''),
        isMandatory: mandatoryFunction.iccidMigration(telecomCharacteristicsData?.prestationType),
      }
    case 'previousProvider':
      return {
        isValid: validations.previousProvider(telecomCharacteristicsData.previousProvider ?? ''),
        isMandatory: mandatoryFunction.previousProvider(telecomCharacteristicsData?.prestationType),
      }

    default:
      console.error('No validation and mandatory info for field : ' + field)
      return false
  }
}

export default TelecomFieldsValidation
